import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase configuration is read from .env (REACT_APP_* variables).
// See: https://firebase.google.com/docs/web/setup
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
